import { useSelector, useDispatch } from 'react-redux'
import { REDUX_PROMPT_TYPES } from 'tennders-common/stores/prompt/action'

const useShowDoc = () => {
  const dispatch = useDispatch()
  const document = useSelector((state) => state.prompt.showDoc)
  const setDocument = (doc) => dispatch({
    type: REDUX_PROMPT_TYPES.SHOW_DOC,
    payload: doc
  })

  return {
    setDocument,
    document
  }
}

export default useShowDoc
